// extracted by css-extract-rspack-plugin
export default {"root":"root-xCtYik authenticator-D4U3Rq","content":"content-YPtowD content-NFrjKj","logo":"logo-FNm09i logo-XDB8Tn","text":"text-NVoihl text-Wj2oMQ"};